module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kristina Hagman, Elizabeth Kaye\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KRISTINA HAGMAN is an artist who has been featured in the"), _c('I'), _c('I', [_vm._v("Los Angeles Times, USA Today, People ")]), _vm._v("magazine, "), _c('I', [_vm._v("Closer ")]), _vm._v("magazine (UK), and more. She is the daughter of Larry Hagman and granddaughter of Mary Martin and lives in Santa Monica, California.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12gd7Tt/tc-custom/9781466888340.jpg?1731154772924",
      "alt": "This image is the cover for the book Eternal Party"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eternal Party\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An intimate and revealing portrait of the TV star who played J.R. on "), _c('i', [_vm._v("Dallas—")]), _vm._v("as seen through the eyes of his daughter.")]), _c('br'), _c('br'), _vm._v("When you have a very famous father, like mine, everyone thinks they know him. My dad, Larry Hagman, portrayed the ruthless oilman J.R. on the TV series "), _c('i', [_vm._v("Dallas")]), _vm._v(". He was the man everyone loved to hate, but he had a personal reputation for being a nice guy who lived by his motto: DON’T WORRY! BE HAPPY! FEEL GOOD! "), _c('br'), _c('br'), _vm._v("Dad had a famous parent, too—Mary Martin, best known for playing Peter Pan on Broadway. Both were beloved performers, masters of crafting their public personas. But their relationship was complex and often fraught."), _c('br'), _c('br'), _vm._v("In the hours before he died, I heard my dad beg for forgiveness, though he could not tell me what troubled him. After he died, I was compelled to learn why he felt the need to be forgiven. As I pursued the mystery of my happy-go-lucky, pot-smoking, LSD-taking dad, I came to know him—and my grandmother—better than I had known them in life.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0